module.exports = __webpack_public_path__ + "static/img/dia-bg2.4642305b.png";